import React, { useState } from 'react'
import shortid from 'shortid'

import Dialog from '@react/react-spectrum/Dialog'
import { Form, FormItem } from '@react/react-spectrum/Form'
import Select from '@react/react-spectrum/Select'
import Switch from '@react/react-spectrum/Switch'
import Textfield from '@react/react-spectrum/Textfield'

import FieldInfo from 'components/FieldInfo'

import { TRIGGERS_TYPES } from '../../../config/constants'

const DEFAULT_EFFECT_TYPE = TRIGGERS_TYPES.beacon.options[0].value

const getEmptyTrigger = (type) => ({
  id: `${type}-${shortid()}`,
  type,
  name: '',
  minor: '',
  major: '',
  uuid: '',
  effect: {
    type: DEFAULT_EFFECT_TYPE,
    value: '',
  },
})

export const mapBeaconForDisplay = (t) => ({
  id: t.id,
  type: t.type,
  name: t.name,
  setup: `minor:\xa0${t.minor}\xa0| major:\xa0${t.major}\xa0| uuid:\xa0${t.uuid}`,
  effect: t.effect ? `${t.effect.type}: ${t.effect.value}` : '',
})

export const BeaconDialog = ({ trigger, canEdit, onSave, onClose }) => {
  const [t, sT] = useState(trigger || getEmptyTrigger('beacon'))

  const onChange = (fieldName) => (value) => {
    sT((t) => ({ ...t, [fieldName]: value }))
  }

  const setEffect = (fieldName) => (value) => {
    sT((t) => ({ ...t, effect: { ...t.effect, [fieldName]: value } }))
  }

  const save = () => {
    onSave(t)
    onClose()
  }

  return (
    <Dialog
      title='Beacon Trigger'
      confirmLabel='Save'
      cancelLabel='Discard'
      className='beacon-dialog'
      size='L'
      onConfirm={save}
      confirmDisabled={!canEdit}
      onCancel={onClose}
    >
      <Form>
        <FormItem label='Name'>
          <Textfield name='name' value={t.name || ''} onChange={onChange('name')} disabled={!canEdit} />
        </FormItem>

        <FormItem label='Minor'>
          <Textfield name='minor' value={t.minor || ''} onChange={onChange('minor')} disabled={!canEdit} />
        </FormItem>

        <FormItem label='Major'>
          <Textfield name='major' value={t.major || ''} onChange={onChange('major')} disabled={!canEdit} />
        </FormItem>

        <FormItem label='UUID'>
          <Textfield name='uuid' value={t.uuid || ''} onChange={onChange('uuid')} disabled={!canEdit} />
        </FormItem>
        <FormItem label='EventId'>
          <Textfield name='eventId' value={t.eventId || ''} onChange={onChange('eventId')} disabled={!canEdit} />
          <FieldInfo title='Event Id'>
            Provide Journey's eventId if you want to send push/in-app on entry or exit of the beacon.
          </FieldInfo>
        </FormItem>
        <FormItem label='Effect Type'>
          <Select
            name='effectType'
            options={TRIGGERS_TYPES.beacon.options}
            value={t.effect?.type}
            onChange={setEffect('type')}
            disabled={!canEdit}
          />
        </FormItem>

        <FormItem label='Effect Value'>
          <Textfield
            name='effectValue'
            value={t.effect?.value || ''}
            onChange={setEffect('value')}
            disabled={!canEdit}
          />
        </FormItem>

        <FormItem label='Debug Message'>
          <Switch
            name='showNotification'
            checked={t.showNotification}
            onChange={(v) => canEdit && onChange('showNotification')(v)}
          />
          <FieldInfo title='Enable Debug Message'>
            Switch this on to receive an in-app message every time this Beacon is detected. <br />
            This feature is meant fortesting purposes only.
          </FieldInfo>
        </FormItem>
      </Form>
    </Dialog>
  )
}
